import React from 'react';

import utils                    from '../../../../../../utils';
import Context                  from '../../../../../../context';
import convertGregorianToJalali from '../../../../../../utils/convertGregorianToJalali';

import { useTranslation } from 'react-i18next';
import {
  UserInformation,
  TableNullData,
} from '../../../../../../components';

import './index.scss';


type Props = {
  data: any;
};

const Body: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  if (!props?.data || props?.data?.length <= 0) return <TableNullData />;
  return (
    <tbody id="company-all-factors-body-container">
      {props?.data?.map((item: any, index: number) =>
        (
          <tr
            key={`files-tr-${index}`}
            className={item?.isPaid2Company ? '' : 'green-row'}
          >
            <td className="table-text">
              <UserInformation
                name        = { item?.driver?.firstName   }
                avatar      = { item?.driver?.avatar      }
                lastName    = { item?.driver?.lastName    }
                phoneNumber = { item?.driver?.phoneNumber }
              />
            </td>
            <td className="table-text">
              <UserInformation
                name        = { item?.parent?.firstName   }
                avatar      = { item?.parent?.avatar      }
                lastName    = { item?.parent?.lastName    }
                phoneNumber = { item?.parent?.phoneNumber }
              />
            </td>
            <td className="table-text">
              <UserInformation
                name     = { item?.student?.firstName }
                avatar   = { item?.student?.avatar    }
                lastName = { item?.student?.lastName  }
              />
            </td>
            <td className="table-text">
              {utils.convertNumberToPrice(item?.price)} {t("toman")}
            </td>
            <td className="table-text">
              {utils.convertNumberToPrice(item?.shares.company + item?.shares.admin)} {t("toman")}
            </td>
            <td className="table-text">{t(item?.payerType)}</td>
            <td className="table-text">{item?.isPaid2Company ? 'پرداخت شده' : 'پرداخت نشده'}</td>
            <td className="table-text">
              {convertGregorianToJalali({date: item?.paidDate, format: "HH:mm - jYYYY/jMM/jDD"})}
            </td>
            <td className="table-text">
              {convertGregorianToJalali({date: item?.createdAt, format: "HH:mm - jYYYY/jMM/jDD"})}
            </td>
          </tr>
        )
      )}
    </tbody>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Body;
